import { LockOutlined } from "@ant-design/icons"
import { Image } from "antd"
import Link from "next/link"
import { getCompressedImageUrl } from "@/utils/utils"
import styles from "@/styles/view-cart.module.scss"

interface AddOnDealRowProps {
  record: any
  status?: "normal" | "locked"
}

const AddOnDealRow = ({ record, status = "normal" }: AddOnDealRowProps) => {
  const isLocked = status === "locked"
  const imageSrc = record.image || (record.defaultFullUrl ? getCompressedImageUrl(record.defaultFullUrl, 112) : '')
  const name = record.productName || record.name || ''

  return (
    <div className={`${styles['goods-box']} ${styles['addon-deal-row']} ${isLocked ? styles['addon-deal-row-locked'] : ''}`}>
      <Link href={record.url || '#'} legacyBehavior>
        <a
          rel="noopener noreferrer"
          className={`${styles['goodsImg']} ${isLocked ? styles['locked-addon-img'] : ''}`}
        >
          <Image
            alt={name}
            src={imageSrc}
            width="100%"
            height="100%"
            preview={false}
          />
        </a>
      </Link>
      <div className={styles['goodsInfo']}>
        <Link href={record.url || '#'} legacyBehavior>
          <a rel="noopener noreferrer" className={styles['name']}>{name}</a>
        </Link>
        {isLocked && (
          <div className={styles['locked-addon-copy']}>
            <div className={styles['locked-addon-title']}>
              <LockOutlined />
              <span>You haven&apos;t reached the minimum spend required for this add-on deal.</span>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default AddOnDealRow
